import { ChangeDetectionStrategy, Component, HostListener, inject, NgZone, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { TranslationService } from '@cbcore/services/translation/translation.service';
import { UtilService } from '@cbcore/services/utils/utils/utils.service';
import { CommunicationHandlerService } from '@cbcore/services/utils/communication-handler/communication-handler.service';
import { WindowBridgeService } from '@cbcore/services/utils/window-bridge/window-bridge.service';
import { SentryService } from '@cbcore/services/sentry/sentry.service';
import { CustomMenuComponent } from './custom-components/menu/custom-menu.component';
import { FooterComponent } from './custom-components/footer/footer';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, RouterOutlet, CustomMenuComponent, FooterComponent]
})
export class AppComponent implements OnInit {
  private zone = inject(NgZone);
  public ready: boolean | undefined;
  private allowedOrigins: string[] = [
    'http://local.nebula.stg-cbus.com:8000',
    'http://localhost:3000',
    'https://dev-play.midolotto.com',
    'https://staging-play.midolotto.com',
    'https://sandbox-play.midolotto.com',
    'https://play.midolotto.com'
  ];

  constructor(
    private _translationService: TranslationService,
    private utilsService: UtilService,
    private xcommunicationHanderService: CommunicationHandlerService,
    private windowBridgeService: WindowBridgeService,
    private sentryService: SentryService,
  ) {
    this.utilsService.setTheme(false, 'light');
    this.windowBridgeService.register('receiveGeoValidationResult', this.receiveGeoValidationResult.bind(this))
  }
  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent): void {
    this.zone.run(() => {
      // if (!this.allowedOrigins.includes(event.origin)) return;

      console.log('Received message from:', event.origin, event.data);

      if (event.data?.message === 'geo_validation_success') {
        this.xcommunicationHanderService.receiveMessages('geo_validation_success');
      }
    });
  }

  ngOnInit() {
    this._translationService.ready().subscribe(
      (_data: any) => {
        this.ready = true
      }
    );
  }

  receiveGeoValidationResult(message): void {
    const currentTimestamp = new Date();
    this.sentryService.logError('receiveGeoValidationResult at: ' + currentTimestamp + ' -- ', message);
    console.log('receiveGeoValidationResult: ' + message);
    if (message && message === 'geo_validation_success') {
        this.xcommunicationHanderService.receiveMessages('geo_validation_success');
    }
  }
}
